module.exports = __webpack_public_path__ + "img/other-purple.739b854a.png";